import React from 'react';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/react-hooks';
import store from '../Common/store';
import { client } from '../Common/gql/client';
import AppViewContainer from './AppViewContainer';

const App: React.FC = props => {
    return (
        <ApolloProvider client={client}>
            <Provider store={store}>
                <AppViewContainer {...props} />
            </Provider>
        </ApolloProvider>
    );
};

export default App;
